/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { MyLibraryPeopleFilterViewModel } from "../types/MyLibraryPeopleFilterViewModel.ts";

export const myLibraryPeopleFilterViewModelSchema = z.object({
  email: z
    .string()
    .describe(
      "E-mails a filtrar, separados por vírgula. A comparação ignora maiúsculas, minúsculas e espaços em volta. Opcional.",
    )
    .nullish(),
  page: z.optional(
    z.number().int().default(1).describe("Página desejada, começando em 1."),
  ),
  pageSize: z.optional(
    z
      .number()
      .int()
      .default(25)
      .describe("Quantidade de registros por página, entre 1 e 500."),
  ),
}) as unknown as ToZod<MyLibraryPeopleFilterViewModel>;
